import { render, staticRenderFns } from "./desc.vue?vue&type=template&id=165d9bb6&"
import script from "./desc.vue?vue&type=script&lang=js&"
export * from "./desc.vue?vue&type=script&lang=js&"
import style0 from "./desc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports